import { Injectable } from '@angular/core';
import * as hexRgb from 'hex-rgb';

@Injectable({ providedIn: 'root' })

export class MatchTrackerService {

    constructor() { }

    getRowStyle(sideColors: string[],isReverse: boolean): string {
        const convertedSide1Color = this.convertArrayToRgba(hexRgb.default(sideColors[0], { format: 'array' }));
        const convertedSide2Color = this.convertArrayToRgba(hexRgb.default(sideColors[1], { format: 'array' }));

        return isReverse
            ? `linear-gradient(to right, ${convertedSide2Color} 50%, ${convertedSide1Color} 50%)`
            : `linear-gradient(to right, ${convertedSide1Color} 50%, ${convertedSide2Color} 50%)`;
    }

    convertArrayToRgba(array: any[]) {
        return `rgba(${array.toString()})`;
    }

}
